//=============== production_api==================

export const baseurl = "https://paxarapi.suffixit.com";
export const BASEURL = "https://paxarapi.suffixit.com";
export const socketUrl = "wss://paxarapi.suffixit.com/ws-endpoint";

//===============partho_dash==================

// export const baseurl = "http://172.168.21.95:8082";
// export const socketUrl = "ws://epiciotapi.suffixit.com:8082/ws-endpoint";

//===============Nasim_Vhai==================

// export const baseurl = "http://172.168.23.85:8082";
// export const socketUrl = "ws://172.168.23.85:8082/ws-endpoint";

//===============Bappi_Vhai==================

// export const baseurl = "http://172.168.20.53:8030";
// export const BASEURL = "http://172.168.20.53:8030";
// export const socketUrl = "ws://172.168.20.53:8030/ws-endpoint";
